import React, { useEffect } from 'react'

import { PageTab, PageTabSection as Props } from '../../../../types/graphql'

import { TemplateProps } from './Template'

export function useViewModel({ tabs, ...rest }: Props & { index?: number }): TemplateProps {
  const [activeTab, setActiveTab] = React.useState<PageTab>(tabs![0]!)

  const getOnClickTab = (tab: PageTab) => (_event: React.MouseEvent<HTMLElement>) => {
    setActiveTab(tab)
  }

  useEffect(() => {
    setActiveTab(tabs.find(o => o.id === activeTab?.id) ?? tabs[0]!)
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs])

  return {
    ...rest,
    activeTab,
    getOnClickTab,
    tabs,
  }
}
